import { get } from 'lodash'
import fieldPropTypes from './FieldPropTypes'
import DurationTextField from './DurationTextField'

const createDurationFieldChangeHandler = (name, setFieldValue) => value => setFieldValue(name, value)

const FormDurationField = props => {
  const {
    classes,
    label,
    field,
    required,
    textFieldProps,
    form: { errors, touched, setFieldValue },
  } = props

  return (
    <DurationTextField
      {...field}
      onChange={createDurationFieldChangeHandler(field.name, setFieldValue)}
      label={label}
      required={required}
      error={!!get(touched, field.name) && !!get(errors, field.name)}
      helperText={!!get(touched, field.name) && get(errors, field.name)}
      classes={classes}
      fullWidth={true}
      {...textFieldProps}
    />
  )
}

FormDurationField.propTypes = fieldPropTypes

export default FormDurationField
